import { fetchGet } from '../helperApi'

export const fetchCustomerDelegationsByCompanyApi = (companyId, customerId) => {
    return fetchGet(`company/${companyId}/customer/${customerId}/delegations`)
}
